import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { RequestService } from './request.service';
import { CommonResponse } from '../models/responses/common-response';

@Injectable({
  providedIn: 'root'
})
export class FingerprintService {

  constructor(private requestService: RequestService) { }

  checkFingerprint(idcard: string | null = null, ben_id: string | null = null, claim_request_id: string | null = null): Observable<CommonResponse<{ has_fingerprint: boolean, is_member: boolean, ben_id?: string | null }>> {
    return this.requestService.postJSON("/fingerprint/check", {
      data: { idcard, ben_id, claim_request_id },
      option: { is_loading: true }
    });
  }

  getFingerprintData(idcard: string | null = null, ben_id: string | null = null, claim_request_id: string | null = null): Observable<CommonResponse<any[]>> {
    return this.requestService.postJSON("/fingerprint/data", {
      data: { idcard, ben_id, claim_request_id },
      option: { is_loading: true }
    });
  }

  saveFingerprintRecord(formData: FormData): Observable<CommonResponse<any>> {
    return this.requestService.postData("/fingerprint/save", {
      data: formData,
      option: { is_loading: true }
    });
  }

  getRecordsByClaimRequest(claim_request_id: string): Observable<CommonResponse<any[]>> {
    return this.requestService.getJSON(`/fingerprint/records/${claim_request_id}`, {
      data: {},
      option: { is_loading: true }
    });
  }

  verifyFace(photo: Blob | File, ben_id: string | null, claim_request_id: string | null): Observable<CommonResponse<any>> {
    const formData = new FormData();
    formData.append("photo", photo, "photo.png");
    if (ben_id) formData.append("ben_id", ben_id);
    if (claim_request_id) formData.append("claim_request_id", claim_request_id);
    return this.requestService.postData("/fingerprint/verify-face", {
      data: formData,
      option: { is_loading: true }
    });
  }

  getFaceData(ben_id: string | null): Observable<CommonResponse<{ has_photo: boolean, is_member: boolean }>> {
    return this.requestService.postJSON("/beneficiary/photo/template/data", {
      data: { ben_id },
      option: { is_loading: false }
    });
  }
}
